import React from 'react';
import ReactDOM from 'react-dom';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '../node_modules/leaflet/dist/leaflet.css'
import './styles/index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  React.createElement(App, {}, null),
  document.getElementById('root')
);
registerServiceWorker();
